import updateSessionWithEmail from 'utils/pivot/session/updateSessionWithEmail'
import buildControllerEmail from 'core/controllers/buildControllerEmail'
import sendApplicantContext from 'core/services/sendApplicantContext'
import { IS_AGENT } from 'core/constants/environment'
import store from 'utils/store/withMiddleware'
import innerHTML from 'utils/DOM/innerHTML'
import proxyStorage from 'proxy-storage'
import { sendEmailQuoteEvent } from 'core/services/email/blueshift/implementations/email-quote'

function saveThisQuote({ getPath, placement, defaultEmail = '', tags }) {
  const modalNode = $('#saveThisQuote')
  const form = document.forms['save-quote-form']
  const email = buildControllerEmail({ input: form['save-quote-email'] })
  let refSetTimeout
  email.setValue(defaultEmail)

  form.addEventListener('submit', function handleSubmitSaveQuote(e) {
    e.preventDefault()

    const status = email.getStatus()
    if (status.valid) {
      const hcStorage = proxyStorage.getItem('hc')
      hcStorage.contact.email_address = status.value
      defaultEmail = status.value
      proxyStorage.setItem('hc', hcStorage)

      if (!IS_AGENT) {
        updateSessionWithEmail(status.value).then(response => {
          store.update({ hcStorage: response }, true)
          sendEmailQuoteEvent(`https://${window.location.hostname}${getPath()}`)

          const config = { placement: placement }
          const hcStorageUpdated = store.getState().hcStorage
          sendApplicantContext(hcStorageUpdated, config)
        })
      }

      innerHTML('#saveThisQuote__email', status.value)
      modalNode.addClass('saveThisQuote__finish')
      window.dataLayerPushEvent('SUBMIT_SAVE_QUOTE')
      refSetTimeout = setTimeout(function () {
        modalNode.removeClass('saveThisQuote__finish')
        modalNode.modal('toggle')
      }, 5000)
    } else {
      email.validate()
    }
  })

  modalNode.on('hidden.bs.modal', function () {
    if (refSetTimeout) {
      modalNode.removeClass('saveThisQuote__finish')
      clearTimeout(refSetTimeout)
      refSetTimeout = undefined
    } else {
      email.setValue(defaultEmail)
      window.dataLayerPushEvent('CLOSE_SAVE_QUOTE')
    }
  })
}

export default saveThisQuote
